import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Search glyph with an ×, 26px. */
export const SearchComboboxSearchXIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={26} {...props}>
        <path d="M14.625 9.20833L9.20833 14.625" stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.20833 9.20833L14.625 14.625" stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M11.9167 20.5833C16.7031 20.5833 20.5833 16.7031 20.5833 11.9167C20.5833 7.1302 16.7031 3.25 11.9167 3.25C7.1302 3.25 3.25 7.1302 3.25 11.9167C3.25 16.7031 7.1302 20.5833 11.9167 20.5833Z"
            stroke="currentColor"
            strokeWidth="2.16667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M22.75 22.75L18.0917 18.0917" stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Search glyph with an ×, 26px. */
export const SearchComboboxSearchXIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={26} {...props}>
        <path d="M14.625 9.20833L9.20833 14.625" stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.20833 9.20833L14.625 14.625" stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M11.9167 20.5833C16.7031 20.5833 20.5833 16.7031 20.5833 11.9167C20.5833 7.1302 16.7031 3.25 11.9167 3.25C7.1302 3.25 3.25 7.1302 3.25 11.9167C3.25 16.7031 7.1302 20.5833 11.9167 20.5833Z"
            stroke="currentColor"
            strokeWidth="2.16667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M22.75 22.75L18.0917 18.0917" stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
